import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Form, Input } from "antd";
import { observer } from "mobx-react-lite";
import { EUserRole, TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST, TemplateMetaDataField } from "@devowl-wp/api-real-cookie-banner";
import { useTranslation } from "../../../../../others/i18n.js";
import { useStores } from "../../../../../store/root.js";
import { defaultTranslationFlexNamePath } from "../../../../../util/template/form.js";
import { getFieldNameTranslated } from "../../../../../util/template/translation.js";
import { getInputPropsDefaultLang, hasTranslationFlagsChanged } from "../../../../../util/translation.js";
import { FormFieldVisibilityWrapper } from "../formFieldVisibilityWrapper.js";
import { TranslationInputFormFields } from "./translation/language-input/language-input-form-fields.js";
const FormFieldTemplateHeadline = observer(()=>{
    const { t } = useTranslation();
    const { rcbAuthenticationStore, rcbUserSettingsStore: { settings: { translationSettings } } } = useStores();
    const { isTranslationMode } = translationSettings;
    // Triggers form item re-render on translation mode toggle
    const lastKnownTranslationMode = isTranslationMode;
    const form = Form.useFormInstance();
    return /*#__PURE__*/ _jsx(FormFieldVisibilityWrapper, {
        fieldNames: TemplateMetaDataField.Headline,
        permissionCheck: {
            whenRole: EUserRole.Translator,
            roleWhiteList: TRANSLATABLE_METADATA_TEMPLATE_ATTRIBUTES_LIST
        },
        children: /*#__PURE__*/ _jsx(Form.Item, {
            label: getFieldNameTranslated(TemplateMetaDataField.Headline, t),
            extra: t("Will be displayed in overviews."),
            shouldUpdate: (prev, next)=>prev.extends?.identifier !== next.extends?.identifier || hasTranslationFlagsChanged(prev, next, TemplateMetaDataField.Headline) || lastKnownTranslationMode !== isTranslationMode,
            required: true,
            hasFeedback: true,
            children: ()=>{
                return /*#__PURE__*/ _jsxs(_Fragment, {
                    children: [
                        /*#__PURE__*/ _jsx(Form.Item, {
                            name: TemplateMetaDataField.Headline,
                            rules: [
                                {
                                    max: 255
                                },
                                {
                                    required: true,
                                    message: t("Please enter a useful headline.")
                                }
                            ],
                            noStyle: true,
                            hasFeedback: true,
                            children: /*#__PURE__*/ _jsx(Input, {
                                placeholder: t("e.g. Real Cookie Banner"),
                                maxLength: 255,
                                disabled: !rcbAuthenticationStore.hasRole(EUserRole.Creator),
                                ...getInputPropsDefaultLang(translationSettings, TemplateMetaDataField.Headline, form)
                            })
                        }),
                        /*#__PURE__*/ _jsx(TranslationInputFormFields, {
                            flexPathConfig: {
                                absolute: {
                                    namePath: defaultTranslationFlexNamePath(TemplateMetaDataField.Headline)
                                }
                            }
                        })
                    ]
                });
            }
        })
    });
});
export { FormFieldTemplateHeadline };
